import { useState, useCallback } from 'react';

export const useAlert = () => {
  const [alert, setAlert] = useState({
    show: false,
    type: "info", 
    message: null,
  });

  const triggerAlert = useCallback((type, message, duration = 4000) => {
    // Log for debugging
    console.log('Triggering alert:', { type, message });
    
    // Ensure message is not empty
    if (!message || (Array.isArray(message) && message.length === 0)) {
      console.warn('Empty message provided to triggerAlert');
      return;
    }
    
    // Set the alert state
    setAlert({ 
      show: true, 
      type, 
      message 
    });

    // Clear the alert after duration
    const timer = setTimeout(() => {
      setAlert(prev => ({ ...prev, show: false }));
      
      // Completely reset alert after animation
      setTimeout(() => {
        setAlert({
          show: false,
          type: "info",
          message: null
        });
      }, 300);
    }, duration);

    return () => clearTimeout(timer);
  }, []);

  return { alert, triggerAlert };
};